import { PackageType } from "@b2bportal/core-packages";
import { logger } from "@b2bportal/core-utilities";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { PackageSearchQueryParams } from "@tenant/types";
import {
  type NewPackagesSearch,
  initialSearchState,
} from "../../types/packagesSearch";
import { fetchLocations } from "@/pages/Packages/components/PackageLocationAutocomplete/fetchLocations";

export const fetchPackageSearchParams = createAsyncThunk<
  NewPackagesSearch,
  PackageSearchQueryParams,
  { rejectValue: string }
>("packages/fetchSearchParams", async (search, thunkAPI) => {
  const usableOrigin = decodeURIComponent(search.origin);
  const usableDestination = decodeURIComponent(search.destination);

  try {
    const [origin, destination] = await Promise.all([
      fetchLocations(usableOrigin).then((results) => results[0]),
      fetchLocations(usableDestination).then((results) => results[0]),
    ]);
    if (!origin || !destination) {
      return thunkAPI.rejectWithValue("Error fetching locations");
    }

    const requestedSearch: NewPackagesSearch = {
      dateRange: {
        from: search.fromDate,
        until: search.untilDate,
      },
      guests: {
        adultCount:
          search.adults ??
          initialSearchState.searchFormValues.guests.adultCount,
        childAges: search.children ?? [],
        infantOnLapAges: Array(search.infantsOnLap ?? 0).fill(0),
        infantInSeatAges: Array(search.infantsInSeat ?? 0).fill(0),
      },
      origin,
      destination,
      packageType: search.packageType,
      driverAge:
        search.driverAge ?? initialSearchState.searchFormValues.driverAge,
      roomCount:
        search.roomCount ?? initialSearchState.searchFormValues.roomCount,
    };

    return requestedSearch;
  } catch (error) {
    logger.debug(`Error setting package search params, ${error}`);
    const errorMessage = error instanceof Error ? error.message : String(error);

    return thunkAPI.rejectWithValue(errorMessage);
  }
});
